const apiBase = process.env.REACT_APP_ZOOM_API_BASE || '';

async function handleResponse(res, fallbackMessage) {
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) {
    throw new Error(payload?.error || fallbackMessage);
  }
  return payload;
}

export async function getAllModules() {
  const res = await fetch(`${apiBase}/api/modules`);
  return handleResponse(res, 'Unable to load modules.');
}

export async function getModulesForStudent(studentId) {
  if (!studentId) throw new Error('studentId is required');
  const res = await fetch(`${apiBase}/api/modules/student/${studentId}`);
  return handleResponse(res, 'Unable to load modules.');
}

export async function getModulesForCourse(courseId) {
  if (!courseId) throw new Error('courseId is required');
  const res = await fetch(`${apiBase}/api/modules/course/${courseId}`);
  return handleResponse(res, 'Unable to load modules.');
}

export async function getModuleById(moduleId) {
  if (!moduleId) throw new Error('moduleId is required');
  const res = await fetch(`${apiBase}/api/modules/${moduleId}`);
  return handleResponse(res, 'Unable to load module.');
}
